// eslint-disable-next-line import/prefer-default-export
export const CORP_ADMIN = 'corporationAdmin';
export const CHANNEL_ADMIN = 'bookingChannelAdmin';
export const FLEET_ADMIN = 'fleetAdmin';
